import { Form } from 'informed';
import { extends as _extends, objectDestructuringEmpty as _objectDestructuringEmpty, taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _Box from '../../components/Box/index.js';
import _CheckboxGroup from '../../components/Checkbox/CheckboxGroup.js';
import _SelectAllCheckbox from '../../components/Checkbox/SelectAllCheckbox.js';
import DirectoryElement from './DirectoryElement.js';

var _templateObject;
/**
 * Renders DirectoryElements - optionally wraps with CheckboxGroup
 * @param checkbox
 * @param directoryElements
 */
var renderElementsWithCheckboxGroup = function renderElementsWithCheckboxGroup(directoryElements, theme) {
  var uniqueId = Math.floor(Math.random() * 1000) + 1; // need unique ID to avoid field conflicts
  // Temporary styling to make it appear part of the list of directoryElements
  // Future designs have this popped out on the right of the header of Directory w/ no styling or labels
  // Will move this when DirectoryElement also moves it's checkboxes to the right
  var DirectoryElementDiv = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border-bottom: 1px solid #d8d8d8;\n    padding: 0.75rem 0.5rem;\n    &:hover {\n      cursor: pointer;\n      background-color: ", ";\n    }\n    &:focus {\n      outline: none;\n      text-decoration: underline;\n    }\n  "])), function () {
    return theme && theme.palette.grayLightest;
  });
  return /*#__PURE__*/React.createElement(_CheckboxGroup, {
    label: "Directory Checkbox Group",
    hideLabel: true,
    field: "dirCheckboxGroup-".concat(uniqueId)
  }, /*#__PURE__*/React.createElement(DirectoryElementDiv, null, /*#__PURE__*/React.createElement(_SelectAllCheckbox, {
    theme: theme,
    field: "selectAll-".concat(uniqueId)
  })), directoryElements);
};
var Directory = function Directory(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _props$checkbox = props.checkbox,
    checkbox = _props$checkbox === void 0 ? false : _props$checkbox,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    defaultOpen = props.defaultOpen,
    _props$directoryItems = props.directoryItems,
    directoryItems = _props$directoryItems === void 0 ? [] : _props$directoryItems,
    _props$foldersOnly = props.foldersOnly,
    foldersOnly = _props$foldersOnly === void 0 ? false : _props$foldersOnly,
    onCheckboxChange = props.onCheckboxChange,
    onItemSelect = props.onItemSelect,
    _props$selectAllCheck = props.selectAllCheckbox,
    selectAllCheckbox = _props$selectAllCheck === void 0 ? false : _props$selectAllCheck,
    _props$textColor = props.textColor,
    textColor = _props$textColor === void 0 ? 'white' : _props$textColor,
    theme = props.theme,
    title = props.title;
  var directoryElements = directoryItems.map(function (directoryItem) {
    return /*#__PURE__*/React.createElement(DirectoryElement, {
      checkbox: checkbox,
      key: directoryItem.id,
      defaultOpen: defaultOpen,
      directoryItem: directoryItem,
      foldersOnly: foldersOnly,
      onCheckboxChange: onCheckboxChange,
      onItemSelect: onItemSelect,
      theme: theme
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Box, {
    color: color,
    textColor: textColor,
    type: "header",
    theme: theme
  }, title), /*#__PURE__*/React.createElement(_Box, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Form, null, checkbox && selectAllCheckbox ? renderElementsWithCheckboxGroup(directoryElements, theme) : directoryElements)));
};
var _Directory = withDefaultTheme(/*#__PURE__*/memo(Directory));

export default _Directory;
export { Directory };
